module.exports = __webpack_public_path__ + "img/logo-top-companies.6a726582.jpg";